module.exports = __webpack_public_path__ + "assets/pastebin.b51a4598.svg";